if (typeof KlaviyoInternalLinkCleaner === 'undefined') {
  class KlaviyoInternalLinkCleaner {
    static SELECTORS = { form: '[class*="klaviyo-form"]', nofollowLink: 'a[rel~="nofollow"]' };
    static EVENTS = { klaviyo: 'klaviyoForms' };
    static REL_NOFOLLOW = 'nofollow';

    constructor () {
      if (!document.querySelector(KlaviyoInternalLinkCleaner.SELECTORS.form)) return;
      // shop host keeps links internal on preview domains, where location.hostname doesn't match
      this._internalHosts = new Set(
        [window.location.hostname, document.currentScript?.dataset.shopHost].filter(Boolean)
      );
      this._abort = new AbortController();
      this._scheduled = false;
      this._observer = new MutationObserver(() => this._schedule());
      this._start();
    }

    _start () {
      this._observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener(
        KlaviyoInternalLinkCleaner.EVENTS.klaviyo,
        () => this._schedule(),
        { signal: this._abort.signal }
      );
      this._clean();
    }

    _schedule () {
      if (this._scheduled) return;
      this._scheduled = true;
      window.requestAnimationFrame(() => {
        this._scheduled = false;
        this._clean();
      });
    }

    _clean () {
      document
        .querySelectorAll(KlaviyoInternalLinkCleaner.SELECTORS.nofollowLink)
        .forEach((link) => this._stripIfInternal(link));
    }

    _stripIfInternal (link) {
      if (!this._internalHosts.has(link.hostname)) return;
      if (!link.closest(KlaviyoInternalLinkCleaner.SELECTORS.form)) return;
      const rel = (link.getAttribute('rel') || '')
        .split(/\s+/)
        .filter((token) => token && token !== KlaviyoInternalLinkCleaner.REL_NOFOLLOW)
        .join(' ');
      rel ? link.setAttribute('rel', rel) : link.removeAttribute('rel');
    }

    destroy () {
      this._observer?.disconnect();
      this._abort?.abort();
    }
  }

  window.KlaviyoInternalLinkCleaner = KlaviyoInternalLinkCleaner;
  new KlaviyoInternalLinkCleaner();
}
